<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="loginUserPermission.indexOf('qr_code_scan_list') > -1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">Inventory Scan List</div>
                        <button type="button" id="exportQRCodeList" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="loadQRCodeScanData(true)">
                            <span>Export</span>
                        </button>
                    </div>
                    <div class="page-title-container">
                        <div class="page-name">
                            <VueCtkDateTimePicker v-model="date_picker_dates"
                                range
                                :only-date="date_picker_options.onlyDate"
                                :only-time="false"
                                :output-format="date_picker_options.outputFormat"
                                :format="date_picker_options.inputFormat"
                                :formatted="date_picker_options.formatted"
                                :noClearButton="date_picker_options.noClearButton"
                                :custom-shortcuts="date_picker_options.customShortcuts"
                                @input="changeDatePickerDate()"
                                :maxDate="date_picker_options.maxDate"
                            ></VueCtkDateTimePicker>
                        </div>
                        <button type="button" class="ml-1 btn btn-primary pull-right themebutton" v-on:click="loadQRCodeScanData(false)">
                            <span>Apply Filter</span>
                        </button>
                        <button type="button" class="ml-1 btn btn-primary pull-right themebutton" v-on:click="clearFilter()">
                            <span>Clear Filter</span>
                        </button>
                    </div>
                <vue-good-table
                    ref="QRCodeScanList"
                    mode="remote"
                    title="QRCode Scan List"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                    }"
                    :search-options="{
                    enabled: false,
                    }">
                    
                    <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'count'" class="table-action">
                                <router-link title='View Inventory Scan Report' class="btn edit-btn-vvg waves-effect pull-left color-blue" v-bind:to="{name: 'ViewQRCodeDetails',params:{id:props.row.id}}">
                                    {{props.formattedRow[props.column.field]}}
                                </router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <!-- <div slot="selected-row-actions">
                        <template>
                            <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'inactive')" class="btn btn-success waves-effect row-deactivate-btn">Deactivate</button>
                            <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState(0, 'active')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                        </template>
                    </div> -->
                </vue-good-table>     
            </div> 
        </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    import EventBus from "../../components/event-bus";
    Vue.use(VueGoodTable);
    Vue.component("app-footer", Footer);
    var self;
    export default {
        name: 'ListQRCodeScan',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                loginUserPermission: ['qr_code_scan_list'],
                firstLoad: 0,
                columns: [
                    {
                        label: 'Name',
                        field: 'updated_by',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Scan Date',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            // placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Scan Count',
                        field: 'count',
                        filterable: false,
                        sortable: true,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Scan Count", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    /* {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    }, */
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                },

                date_picker_options: {
                    range: true,
                    onlyDate: true,
                    outputFormat: 'YYYY-MM-DD',
                    inputFormat: 'YYYY-MM-DD',
                    formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
                    noClearButton: true,
                    maxDate : '',
                    // Getting error when using the for date picker options
                    // 'no-shortcuts': false,
                    customShortcuts : [
                        { key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: true },
                        { key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
                        { key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
                        { key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
                        { key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                    ]
                },
                date_picker_dates: "",
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuslug = "qr-code-scan-list";
            self.date_picker_dates = {
              "start": '',
              "end": ''
            };
            self.getRole();
            self.loadQRCodeScanData(false);
        },
        methods: {
            changeDatePickerDate : function () {
              // self.datePickerError = '';   
            },
            clearFilter(){
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                self.loadQRCodeScanData(false);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadQRCodeScanData(false);
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadQRCodeScanData(false);
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('count');
                    field: ('updated_at');
                    field: ('updated_by');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.count || filters.updated_at || filters.updated_by) {
                    self.loadQRCodeScanData(false);
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['QRCodeScanList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadQRCodeScanData(false);
            },
            loadQRCodeScanData(isExcelFlag) {
                self.firstLoad = 1;
                if (self.date_picker_dates.end === null) {
                    self.date_picker_dates.end = self.date_picker_dates.start;
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort,
                    tz: moment.tz.guess(),
                    isExcelFlag: isExcelFlag,
                    from_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.start).format("YYYY-MM-DD") : "",
                    to_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.end).format("YYYY-MM-DD") : "",
                };
                self.showLoader();
                HTTP.post("listqrcodescandata", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            if(response.data.message == 'success export') {
                                location.href = response.data.content;
                            } else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });

            },
        },
    };
    EventBus.$on('roleAndPermissions', function (isLogin, id, name, system_year, loginUserPermission) {
        if (typeof (self) != "undefined") {
            self.loginUserPermission = [];
            /* self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year; */
            self.loginUserPermission = loginUserPermission;
        }
    });
    EventBus.$on('exportQRCodeList', function (data) {
        if (typeof (self) != "undefined") {
            self.loadQRCodeScanData(data);
        }
    });
</script>
<style scoped>
    .color-blue {
        color: blue;
    }
    .vgt-wrap {
        position: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/QRCode/ListQRCodeScan.vue